import { defaultThemes } from "@/components/fluent-datatable-compat";

export const dataTableStyles: any = {
    header: {
        style: {
            minHeight: '56px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    head: {
        style: {
			color: defaultThemes.default.text.primary,
            fontSize: '14px',
            fontWeight: 'bold !important',
		}
    },
    headRow: {
        style: {
            borderBottomStyle: 'solid',
            borderBottomWidth: '1px',
            borderBottomColor: defaultThemes.default.divider.default,
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            // Don't override width - let column width property control it
        },
    },
    rows: {
        style: {
            '&:not(:last-of-type)': {
				borderBottomStyle: 'none',
				borderBottomWidth: '0px',
			},
        },
    },
    cells: {
        style: {
            fontSize: '14px',
            border: 'none',
            paddingLeft: '8px',
            paddingRight: '8px',
            // Don't override width - let column width property control it
        },
    },
    table: {
        style: {
            width: '100%',
            tableLayout: 'fixed',
        },
    },
};